export const ITEMS_GET = 'ITEMS::GET'
export const ITEMS_LOADING = 'ITEMS::LOADING'
export const ITEMS_UPDATE = 'ITEMS::ITEM::UPDATE'
export const CLOSE_LIVE_ITEM = 'ITEMS::ITEM:CLOSE_LIVE'
export const ITEMS_BIDS_GET = 'ITEMS::BIDS::GET'
export const ITEMS_BIDS_SET = 'ITEMS::BIDS::SET'
export const ITEMS_BIDS_CLEAR = 'ITEMS::BIDS::CLEAR'
export const ITEMS_BIDS_LOADING = 'ITEM::BIDS::LOADING'
export const ITEMS_SET_BID_ID = 'ITEMS::BID_ID::SET'
export const ITEMS_BIDS_PUSH = 'ITEMS::BIDS::PUSH'
export const ITEMS_BIDS_REMOVE = 'ITEMS::BIDS::REMOVE'

export const ITEMS_PURCHASES_SET = 'ITEMS::PURCHASES::SET'
export const ITEMS_PURCHASES_CLEAR = 'ITEMS::PURCHASES::CLEAR'
export const ITEMS_PURCHASES_LOADING = 'ITEM::PURCHASES::LOADING'
export const ITEMS_SET_PURCHASE_ID = 'ITEMS::PURCHASE_ID::SET'
export const ITEMS_PURCHASES_PUSH = 'ITEMS::PURCHASES::PUSH'
export const ITEMS_PURCHASES_REMOVE = 'ITEMS::PURCHASES::REMOVE'

export const ITEM_PUSH = 'ITEM::PUSH'



// WEBPACK FOOTER //
// ./src/types/actions/items.js